import { httpClient } from "./httpClient";

const getAllWorkTimeRequest = () => {
  return httpClient.get("workTimeRequest");
};

export default {
  getAllWorkTimeRequest,
};
